/**
 * @author: Yaochao
 * @date: 2021-07-05 16:45
 * @description：左侧为头像，右侧为文字，一般用户粉丝头像+昵称，商品头像+标题等
 */
import React from "react";
import Util from "../../public/utils";

/**
 *
 * @param headUrl 头像地址
 * @param headText 头像文本
 * @param headImgWidth 头像宽度
 * @param circular 头像是否是圆形
 * @returns {*}
 * @constructor
 */
const DefaultWidth = 44;
const ZkHeadText = ({headUrl: headUrl, headText: headText, headImgWidth: headImgWidth, headImgHeight: headImgHeight, circular: circular}) => {
    // let gender =gender ? gender : '';
    let width = headImgWidth > 0 ? headImgWidth : DefaultWidth;
    let height = headImgHeight > 0 ? headImgHeight : DefaultWidth;
    let wrapStyle = {
        height: height,
        width: width
    };
    return <div className='headTextWrap'>
        <div className={'headTextImg'} style={wrapStyle}>
            <img className={'img'} src={headUrl}
                 style={circular ? {borderRadius: width} : {}}/>
        </div>

        <span>{headText}</span>
        {/*<span>{gender}</span>*/}
    </div>
};

export default ZkHeadText